import { Theme } from "./symbols";

export const statefarmTheme: Theme = {
    name: 'statefarm',
    properties: {
      '--background': '#EC0C21',
      '--on-background': '#0F0F0F',
      '--primary': '#389BFF',
      '--on-primary': '#fff',
      '--secondary': '#B2B4B7',
      '--on-secondary': '#fff',
      '--surface': '#fff',
      '--on-surface': '#0F0F0F',
      '--error': '#EB5945',
      '--on-error': '#fff',
      '--warning': '#F6BB42',
      '--on-warning': '#fff',
      '--color': '#212121',
      '--button-color': '#EC0C21',
      'font-family': 'MecherleSans, Arial'
    },
    settings: {
      roundedButtons: true
    }
  };
